import { useState } from "react";

import PropTypes from "prop-types";

import dataTrustpilot from "common/data/trustpilot/data.json";
import useResizeScreenModified from "common/hooks/useResizeScreenModified";

import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import FormNewsLetter from "components/molecules/FormNewsletter";
import AboutUs from "components/organisms/AboutUs";
import Banner from "components/organisms/Banner";
import IndustryNewsInsights from "components/organisms/IndustryNewsInsights";
import OurPartners from "components/organisms/OurPartners";
import TrustpilotFeedBack from "components/organisms/TrustpilotFeedBack";

const Component = ({ posts, data }) => {
  const [companyName, setCompanyName] = useState("");

  const handleInput = (event) => {
    setCompanyName(event.target.value);
  };

  const handleSubmit = () => {
    window.location.href = `/onboarding/register?country_id=191&company_name=${companyName}`;
  };
  const [screen, setScreen] = useState("DESKTOP");

  useResizeScreenModified(setScreen);

  return (
    <>
      <section>
        {/* <BannerChristmas /> */}
        <Banner
          minHeightBanner="banner-min-h-600"
          title="Setting up your <br/> Singapore business <br/> doesn't need to be <br/> complicated."
          description="We start your Singapore company in hours, take care of administration and compliance nuances."
          bgColor="bg-bbc-gradient-12 bg-[length:180%_180%] animate-[gradientAnimation_10s_ease_infinite]"
          leftClassName="relative mt-4 lg:mt-0 col-12 lg:col-6 xl:col-7 z-40"
          leftContent={
            <div className="mb-10 lg:mb-10">
              <div className="flex flex-col justify-between rounded-full py-1 pr-1 text-sm lg:h-[50px] lg:flex-row lg:bg-white">
                <div className="flex flex-grow items-center lg:px-4">
                  <input
                    id="ipt-company-name"
                    placeholder="Your company name"
                    className="mb-4 w-full truncate rounded-full bg-white px-4 py-2 outline-none lg:mb-0"
                    value={companyName}
                    onChange={handleInput}
                  />
                </div>
                <div className="lg:max-w-[237px]">
                  <button
                    onClick={() => handleSubmit()}
                    className="h-full w-full truncate rounded-full bg-bbc-primary py-2 px-6 text-base text-white"
                  >
                    Register Your Company
                  </button>
                </div>
              </div>
            </div>
          }
          rightClassName="static hidden lg:block lg:col-6 xl:col-5"
          rightContent={
            <>
              {screen === "DESKTOP" && (
                <Img
                  wrapper={{
                    className: "bbc-banner-image-bottom-0 banner-home",
                  }}
                  className="w-full"
                  src="/assets/images/sg/banner-sg-home.png"
                  width={1059}
                  height={815}
                  alt="register a company in Singapore with the help of technology"
                  priority={true}
                />
              )}
            </>
          }
          wave={
            <div className="relative">
              <Img
                src="/assets/images/wave/exclude-wave.svg"
                className="h-full w-full"
                width={1920}
                height={95}
                wrapper={{
                  className: "w-full h-full",
                }}
                alt="banner-img"
              />
            </div>
          }
        ></Banner>
      </section>
      <IndustryNewsInsights data={posts} />
      <AboutUs
        data={data?.dataAboutUs}
        bgImage="/assets/images/common/pexels-gradient.png"
      />
      <OurPartners button={true} />
      <section className="relative pt-10 lg:mb-0 lg:bg-bbc-brand-100 lg:pt-40 lg:pb-8">
        <Img
          className="absolute  left-0 right-0 w-full"
          style={{ top: "-4px" }}
          src="/assets/images/wave/curve_home-wave.svg"
          width={1920}
          height={158}
          wrapper={{ className: "hidden lg:block" }}
          alt="wave3"
        />
        <div className="container">
          <Title
            text="Our Service"
            className="mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:text-left lg:text-bbc-40px"
          />
          <p className="text-center leading-bbc-26 text-bbc-gray lg:text-left">
            We encompass well-rounded corporate services to boost your future
            growth. We offer various digital corporate services from easy
            company formation to professional post-incorporation services to
            help your Singapore business run smoothly during operations.
          </p>
          <div className="row items-center justify-between lg:mt-10">
            <div className="col-12 text-center lg:col-6">
              <Img
                src="/assets/images/common/corporate_secretary-hk_sg.png"
                width={540}
                height={540}
                alt="corporate-secretary"
              />
            </div>
            <div className="col-12 lg:col-5">
              <div>
                <Title
                  as="h3"
                  text="Corporate Secretary"
                  className="mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
                />
                <p className="mb-6 leading-bbc-26">
                  Automate manual tasks with legal template and streamlined
                  workflow. We help you keep focus on what matters to your
                  business. And feel rest assured leaving the formalities to our
                  qualified experts.
                </p>
                <div className="text-center lg:text-left">
                  <Link
                    href="/company-secretary"
                    className="inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white"
                  >
                    Explore
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-6 items-center justify-between lg:mt-10">
            <div className="col-12 order-2 mt-6 lg:col-5 lg:order-0 lg:mt-0">
              <div>
                <Title
                  as="h3"
                  text="Company Incorporation"
                  className="mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
                />
                <p className="mb-6 leading-bbc-26">
                  Bring your business ideas to life and into motion with our
                  innovative company formation services. We utilize scalable
                  technology and industry network to help you go through
                  incorporation with minimal effort and costs.
                </p>
                <div className="text-center lg:text-left">
                  <Link
                    href="/company-incorporation"
                    className="inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white"
                  >
                    Explore
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 text-center lg:col-6">
              <Img
                src="/assets/images/sg/home/company_formation-sg-home.png"
                width={540}
                height={540}
                alt="company-formation"
              />
            </div>
          </div>
          <div className="row items-center justify-between lg:mt-10">
            <div className="col-12 text-center lg:col-6">
              <Img
                src="/assets/images/common/business_accounts-hk_sg.png"
                width={540}
                height={540}
                alt="business-accounts"
              />
            </div>
            <div className="col-12 lg:col-5">
              <div>
                <Title
                  as="h3"
                  text="Business Accounts"
                  className="mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
                />
                <p className="mb-6 leading-bbc-26">
                  We make opening and sorting business bank account simple. Our
                  banking consultations are designed to increase your chance of
                  getting approval, prevent unnecessary paperwork, and reduce
                  waiting time.
                </p>
                <div className="text-center lg:text-left">
                  <Link
                    href="/open-bank-account"
                    className="inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white"
                  >
                    Explore
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-6 items-center justify-between lg:mt-10">
            <div className="col-12 order-1 mt-6 lg:col-5 lg:order-0 lg:mt-0">
              <div>
                <Title
                  as="h3"
                  text="Accounting & Auditing"
                  className="mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
                />
                <p className="mb-6 leading-bbc-26">
                  Eliminate time-consuming accounting tasks from your schedule
                  and keep your tax compliance status green with our qualified
                  accounting service.
                </p>
                <div className="text-center lg:text-left">
                  <Link
                    href="/accounting-and-auditing"
                    className="inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white"
                  >
                    Explore
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 text-center lg:col-6">
              <Img
                src="/assets/images/common/accounting_auditing-hk_sg.png"
                width={540}
                height={479}
                alt="accounting-auditing"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="mb-20 hidden lg:block">
        <Img
          className="w-full"
          src="/assets/images/wave/curve_home1-wave.svg.svg"
          width={1920}
          height={116}
          wrapper={{ className: "hidden lg:block" }}
          alt="wave4"
        />
      </div>
      <section>
        <div className="container">
          <div className="col-12 m-auto lg:col-10">
            <Title className="title-h2 mb-6 pb-0 text-center text-bbc-brand-800">
              Don&apos;t just take our words. <br />
              Hear what our clients say
            </Title>
            <p className="text-center">
              Clients talked about us on{" "}
              <a
                className="font-medium text-bbc-primary hover:text-bbc-secondary-300"
                target="_blank"
                rel="noreferrer"
                href="https://www.trustpilot.com/review/bbcincorp.com"
              >
                Trustpilot
              </a>
            </p>
            <TrustpilotFeedBack data={dataTrustpilot.feedback} />
          </div>
        </div>
      </section>
      <FormNewsLetter bgColor="bg-bbc-gradient-9" />
    </>
  );
};

export default Component;

Component.propTypes = {
  data: PropTypes.object,
  posts: PropTypes.array,
};

Component.defaultProps = {
  data: {},
  posts: [],
};
